<template>
  <billing-dialog
    class="opc-plan-detail-dialog"
    v-model="visible"
    @close="handleCancel"
    @back-event="handleCancel"
  >
    <!--header-->
    <img v-if="logo" :src="logo" alt="" class="opc-plan-detail-dialog__logo">
    <h1 class="opc-plan-detail-dialog__title">{{ title }}</h1>
    <price-list class="opc-plan-detail-dialog__price" :plan-category="planCategory" :unit-type="planUnitMap.room" />
    <ul class="opc-plan-detail-dialog__feature-item-list">
      <li v-for="(feature, index) in featureList" :key="index" v-html="feature" />
    </ul>
  </billing-dialog>
</template>

<script type="text/jsx" lang="jsx">
import { ConfirmComponent, ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { getCurrency, getCurrencySymbol } from '@/utils/currency';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog';
import { planUnitMap } from '@/common/product-unit';
import PriceList from "@/components/price-list.vue";
import BillingDialog from '@/components/billing-dialog.vue';

export default {
  name: 'PlanDetails',
  mixins: [ConfirmComponent],
  components: {
    BillingDialog,
    PriceList,
  },
  props: {
    planCategory: String,
  },
  data() {
    return {
      visible: false,
      logo: '',
      currencySymbol: getCurrencySymbol(getCurrency()),
      title: '',
      monthlyPlan: null,
      annualPlan: null,
      essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog, this.$store),
      featureList: [
        this.$t('billing.zr.feature.wb'),
        this.$t('billing.zr.feature.meeting_zr'),
        this.$t('billing.zr.feature.wireless'),
        this.$t('billing.zr.feature.share'),
      ],
      planUnitMap
    };
  },
  methods: {
    handleSure() {
      this.$tracking.buyInteraction('product details', 'plan details - see full feature list');
    },
  },
  watch: {
    visible(val) {
      this.$tracking.buyInteraction(
        'product details',
        `zoom rooms plan details -  ${val ? 'impression' : 'exit'}`,
      );
    },
  }
};

</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.opc-plan-detail-dialog {
  .zbo-dialog {
    min-width: 522px;
    padding: 70px 60px;
    width: fit-content;
  }

  &__title {
    font-style: normal;
    text-transform: capitalize;
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    margin-bottom: 12px;
  }

  &__price {
    margin-bottom: 12px;
  }

  &__feature {
    &-title {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }

    &-item {
      position: relative;
      padding-left: 20px;
      margin-bottom: 16px;

      &-list {
        list-style: disc;
        padding-left: 14px;

        li {
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%; /* 21px */
          color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
          margin-bottom: 8px;
        }

        li:nth-last-of-type(1) {
          margin-bottom: 0px !important;
        }
      }
    }
  }
}

</style>
